import React from "react";
import { scrollToContact } from "../../../helper";
import SocialMediaLinks from "../../../wrappers/socialMediaLinks";

const Banner = props => {
    return (
        <div className="banner-section" onLoad={a => console.log(a)}>
            <div className="banner-wrapper">
                <div className="banner-background-image"></div>
            </div>
            <div className="banner-left">
                <div className="text-wrapper">
                    <h1>
                        LOOK AFTER YOUR MOST VALUABLE ASSETS, YOUR STAFF AND
                        THEIR HEALTH.
                    </h1>
                    <p>Learn more by getting in touch</p>
                    <button
                        onClick={scrollToContact}
                        className="contact-button"
                    >
                        Contact us
                    </button>
                </div>
            </div>

            <div className="banner-bottom">
                <SocialMediaLinks />
            </div>
        </div>
    );
};

export default Banner;
